import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

export type AuditEntry = {
  id: string;
  action: string;
  actor: { id: string | null; name: string | null; email: string | null };
  target: { type: string | null; id: string | null };
  metadata: Record<string, unknown>;
  created_at: string;
};

export type AuditQuery = {
  page: number;
  limit: number;
  action?: string;
  actor?: string;
  from?: string;
  to?: string;
};

export type AuditResponse = {
  status: string;
  data: AuditEntry[];
  count: number;
  page: number;
  limit: number;
  actions: string[];
};

/** GET /v1/audit (admins only). Empty filters are left out. */
export async function getAuditLog(query: AuditQuery): Promise<AuditResponse> {
  const params = Object.fromEntries(
    Object.entries(query).filter(
      ([, value]) => value !== undefined && value !== '',
    ),
  );
  const { data } = await axios.get(`${API_HOST}/v1/audit`, { params });
  return data;
}
